<template>
  <div class="edit-table">
    <vxe-table show-overflow="" ref="fineTable" :data="subjectList">
      <vxe-table-column min-width="100" field="companyAwardCode" title="奖励预算编码"></vxe-table-column>
      <vxe-table-column min-width="100" field="year" title="年度"></vxe-table-column>
      <vxe-table-column min-width="100" field="companyName" title="公司主体"></vxe-table-column>
      <vxe-table-column min-width="100" field="createName" title="调整人"></vxe-table-column>
      <vxe-table-column min-width="100" field="createDateAll" title="调整时间"></vxe-table-column>
      <vxe-table-column min-width="100" field="adjustAmount" title="调整金额"></vxe-table-column>
      <vxe-table-column min-width="100" field="residueAmount" title="余额"></vxe-table-column>
    </vxe-table>
  </div>
</template>

<script>
import request from '@/found/utils/request';
import { log } from 'mathjs';

export default {
  name: 'BudgetSubject',
  props: {
    value: Array,
    disabled: Boolean,
  },
  watch: {
    value() {
      console.log(this.value);
      this.subjectList = this.value;
    },
  },
  data() {
    return {
      subjectList: [], // 当前关联费用科目数据
    };
  },
  methods: {

  },
};
</script>

<style lang="less" scoped>
.edit-table {
  padding-left: 50px;

}
</style>
